/* eslint-disable */
import React from "react";
// @material-ui/core components
import {
  Input,
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  InputAdornment,
} from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Search from "@material-ui/icons/Search";
import Button from "components/CustomButtons/Button.js";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import DateFnsUtils from "@date-io/date-fns";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import { db } from "../Firebase/firebase.js";
import ls from "local-storage";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import moment from "moment";
import styles from "assets/jss/material-dashboard-react/views/EventStyle.js";
import { element } from "prop-types";

const useStyles = makeStyles(styles);
export default function PurchasedProducts() {
  const theme = useTheme();
  var mobileratio = useMediaQuery(theme.breakpoints.down("sm"));
  var desktop = useMediaQuery(theme.breakpoints.between("2490", "4000"));

  /////////Other hooks//////////
  //Seach
  const searchref = React.useRef("");
  const [searchflag, setsearchflag] = React.useState(true);
  //View
  const [viewflag, setviewflag] = React.useState(false);
  ////////Handling data change////////
  const [editDocID, setEditDocID] = React.useState("");
  const [rows, setRows] = React.useState([]);


  const [customername, setCustomername] = React.useState("")
  const [productname, setProductname] = React.useState("")
  const [cost, setCost] = React.useState("")
  const [address, setAddress] = React.useState("")
  const [date, setDate] = React.useState("")




  //Handling Add Event dialog
  const [open, setOpen] = React.useState(false);




  //Handling View/Update Dialog
  const [openViewDialog, setViewDialog] = React.useState(false);

  const handleViewClickOpen = () => {
    setViewDialog(true);
  };
  const handleViewArrowClose = () => {
    setViewDialog(false);
  };

  const handleViewClose = () => {
    if (viewflag === true) {
      setViewDialog(false);
    } else {

    }
  };

  //Handling Delete
  const [opendeletebox, setopendeletebox] = React.useState(false);
  const [deleteDocID, setDeleteDocID] = React.useState(false);


var listOfProducts = []

  ///////////////CRUD/////////////////


  //Get events function
  const GetProducts = async () => {
    let newArray = [];
  await  db.collection("purchasedProducts")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data());
        });
        // setRows(newArray);
      }).then(async () => {
       await db.collection("products").get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(doc.data())
            // listOfProducts.push(doc);
            newArray.forEach((element) => {
              if (element.productId === doc.data().productId) {
                element.productName = doc.data().name;
               
              }
            })
            
          });
        })
        setRows(newArray);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });

 
      

  };

  React.useEffect(() => {
    if (ls.get("currentuser") === "") {
      history.push("/login");
    } else {
      GetProducts();
    }
  }, []);





  /////////////Other operations////////////////


  //View Event
  const viewEvent = (row) => {
    setviewflag(true);
    setCustomername(row.name);
    setProductname(row.productName);
    setDate(row.endDate);
    setAddress(row.address);
    setCost(row.cost);

    setViewDialog(true);
  };

  function getProductFromList(product){
   //find the element that has the same productId as the product
    var element = listOfProducts.find(element => element.data().productId === product.productId);
    console.log(element.data());
    
    return element;
  }



  /////////Styling////////
  const classes = useStyles();

  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  return (
    <>

      <br></br>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer
            component={Paper}
            style={{
              height: 450,
              overflowY: "scroll",
              overflowX: "auto",
              display: "inline-block",
            }}
          >
            <Table
              stickyHeader
              style={{ width: "100%" }}
              className={classes.table}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ width: "20%" }}
                    className={[classes.tableheadercell, classes.tablehead]}
                  >
                    Sr.No
                  </TableCell>
                  <TableCell
                    className={[classes.tableheadercell, classes.tablehead]}
                    align="left"
                    style={{ width: "15%" }}
                  >
                    Customer Name
                  </TableCell>
                  <TableCell
                    className={[classes.tableheadercell, classes.tablehead]}
                    align="left"
                  >
                    Purchased Products
                  </TableCell>
                  <TableCell
                    className={[classes.tableheadercell, classes.tablehead]}
                    align="left"
                  >
                    Address
                  </TableCell>
                  <TableCell
                    className={[classes.tableheadercell, classes.tablehead]}
                    align="left"
                    style={{ width: "15%" }}
                  >
                    User ID
                  </TableCell>


                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row,index) =>{
   
                  return (
                    <StyledTableRow key={index}>
                      <TableCell
                        onClick={() => viewEvent(row)}
                        style={{ color: "blue" }}
                        component="th"
                        scope="row"
                      >
                        {++index}
                      </TableCell>
  
                      <TableCell align="left">{row.name}</TableCell>
                   <TableCell align="left">{row.productName}</TableCell>
                      <TableCell align="left">{row.address}</TableCell>
                      <TableCell align="left">{row.uid}</TableCell>
  
  
                    </StyledTableRow>
                  )
                }
                 
                
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <GridContainer justify="flex-end">
        <GridItem>
          <br></br>
          {/* View/Update Dialog */}
          <Dialog
            open={openViewDialog}
            onClose={handleViewArrowClose}
            aria-labelledby="event-title"
            aria-describedby="event-description"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="event-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleViewArrowClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 500, width: 600 }}>
              <div className="event-form">
                <TextField
                  required
                  id="event_name"
                  label="Customer Name"
                  value={customername}
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                {mobileratio ? null : <br></br>}


                <TextField
                  value={productname}
                  required
                  label="Product Name"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br>
                <TextField
                  value={cost}
                  required
                  label="Cost"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />


                {mobileratio ? null : <br></br>}
                {mobileratio ? null : <br></br>}


                {/* <TextField
                  value={date}
                  required
                  label="Date"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                <br></br> */}
                <TextField
                  value={address}
                  required
                  label="Address"
                  variant="outlined"
                  multiline
                  rowsMax={5}
                  style={{ width: mobileratio ? 267 : 540 }}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                style={{
                  marginRight: mobileratio ? 75 : 15,
                  width: mobileratio ? 267 : 560,
                  backgroundColor: "#171942",
                }}
                onClick={handleViewClose}

              >
                Close
              </Button>
            </DialogActions>
          </Dialog>


        </GridItem>
      </GridContainer>
    </>
  );
}
